
export default {
  name: 'loadTable',
  inserted (el, binding, vnode, oldVnode) {
    if (binding.value.noEmit) {
      return
    }
    // 设置节流定时器
    let timer;
    // 滚轮的滚动高度
    let scrollTop = 0;
    // 记录滚动的单元格的个数
    let scrollNum = 0;
    // 滚动单元格的高度
    let columnHeight = 0;
    // 记录旧的开始截取索引，防止重复截取操作
    let oldStartIndex = null;
    // 滚动wrapper容器
    const scrollItem = el.querySelector('.el-table__body-wrapper')
    // 滚动的tabledom
    const tableBody = scrollItem.querySelector('.el-table__body')
    // table渲染的数据条数
    let { dataSize } = binding.value;
    // 获取挂在组件上的值 vnode.data.attrs['data-size']
    // 自动操作滚动bar的函数
    function setData (startIndex, endIndex) {
      const allTrDom = tableBody.querySelectorAll('tr')
      // 如若没有高度则初始化高度
      if (!columnHeight) {
        if (tableBody.getElementsByTagName('tr').length)
          columnHeight = tableBody.getElementsByTagName('tr')[0].offsetHeight;
      }
      // 假设没有设置默认加载条数
      if (!dataSize) {
        dataSize = Math.round(scrollItem.offsetHeight / columnHeight) * 5.38
        if (dataSize > 100) {
          dataSize = 100
        }
        else if (dataSize < 20) {
          dataSize = 20
        }
      }
      if (!endIndex) {
        endIndex = dataSize - 1
      }
      binding.value.handler.call(this, startIndex, endIndex)
      allTrDom.forEach((v, i) => {
        const allTdDom = v.querySelectorAll('td')
        allTdDom.forEach(vv => {
          if (i < startIndex || i > endIndex) {
            vv.style.display = 'none'
          }
          else {
            vv.style.display = ''
          }
        })
      })
    }
    // 执行函数
    scrollItem.addEventListener('scroll', (e) => {
      // 滚上去的条数大于设置条数的1/3的时候，开始预加载下面的数据
      // 数据节流
      clearTimeout(timer)
      timer = setTimeout(() => {
        // 滚动条滚动的高度
        scrollTop = scrollItem.scrollTop;
        scrollNum = Math.floor(scrollTop / columnHeight);
        // 可视区域的格数
        const showColumnNum = Math.floor(scrollItem.offsetHeight / columnHeight)
        // 设置条数总高度大于可视区的高度格数除2
        const averageNum = (dataSize - showColumnNum) / 2
        // 假设
        let startIndex = scrollNum > averageNum ? Math.floor(scrollNum - averageNum) : 0
        // 阻止重复截取
        if (oldStartIndex == startIndex) {
          return
        }
        oldStartIndex = startIndex
        let endIndex = dataSize + startIndex - 1
        setData(startIndex, endIndex)
        // 设置上下顶bar的高度
      }, 50)
    }, false)

    // 配置一次endBar高度
    setTimeout(() => {
      setData(0)
    }, 50)
  },
  componentUpdated: function (el, binding, vnode, oldVnode) {
  },
  unbind () {
  }
};
